<template>
  <div class="luck_draw">
    <!-- 中奖结果 开始 -->
    <div
      class="luck_draw_prize"
      v-for="(item,index) in prizeList"
      :key="index"
    >
      <div class="prize-img" :style="'backgroundColor:'+item.color" :id="item.id" v-if="index !== 4">
        <div class="prize-item" v-if="item.bonus_type === 'none'">
          <p class="img"><img src="../../assets/images/not-win-icon@2x.png" alt=""></p>
          <p class="txt">谢谢参与</p>
        </div>
        <div class="prize-item" v-if="item.bonus_type === 'point'">
          <p class="img"><img src="../../assets/images/integral-icon@2x.png" alt=""></p>
          <p class="txt"><span>{{item.num}}</span>积分</p>
        </div>
        <img v-if="item.bonus_type === 'custom'" :src="item.img" :alt="item.bonus_desc" />
      </div>
      <!-- 抽奖蒙层 -->
      <div v-if="selectPrize !== index && selectPrize !== '' && index !== 4" class="select_sign"></div>
      <!-- 抽奖按钮 -->
      <!-- <span>立即抽奖: {{}}</span> -->
      <div v-if="index == 4 && status == 'active'" class="start" @click="clickDraw()">
        <p class="t">立即抽奖</p>
        <span class="num">
          <p class="n">{{jointLimitNum}}</p>
          <p class="t2">抽奖机会</p>
        </span>
      </div>
      <div v-if="index == 4 && status !== 'active'" class="end">活动结束</div>
    </div>
    <!-- 中奖结果 结束 -->

    <resultModal :showstate="resultStatus" :resultdata="resultData" @closeResult="closeResult"></resultModal>
    <!-- 抽奖机会用完 -->
    <!-- 弹框 -->
    <modal :showstate="winNumStatus" :showTitle="false" :isFooter="false" @close="closeDrawDolag">
        <!-- 抽奖机会用完 -->
        <div slot="text" class="not-win-modal-box">
          <div class="top-img">
            <img src="../../assets/images/not-draw-img@2x.png" alt="">
          </div>
          <div class="title">抽奖机会用完了～</div>
          <!-- <div class="prize-name">你需要先用积分兑换抽奖机会</div>
          <div class="des">才能抽奖哦～</div> -->
          <div class="gobtn" @click="closeDrawDolag">我知道了</div>
        </div>
    </modal>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import api from '@/api/pmall';
import modal from '../modal/modal';
import resultModal from '../resultModal/resultModal';

export default {
  name: 'luckDraw',
  components: {
    resultModal,
    modal,
  },
  props: ['prizeList', 'jointlimit', 'modifiedtime', 'lotteryId', 'status'],
  data() {
    return {
      indexList: [0, 1, 2, 5, true, 8, 7, 6, 3],
      selectPrize: '', // 要选中的下标
      curPrizeId: '', // 当前中奖奖品ID
      rotationNumber: 0, // 记录旋转圈数
      sTime: 120,
      setIntervalTimer: '',
      clickFlag: true,
      resultStatus: false, // 是否显示中奖弹框
      resultData: '', // 中奖结果数据
      winNumStatus: false, // 抽奖无机会弹框
    };
  },
  watch: {
  },
  mounted() {
    console.log('token:', this.$store.state.token);
  },
  computed: {
    jointLimitNum() {
      return this.jointlimit;
    },
    ...mapGetters(['token', 'luckydraw/lotteryId']),
  },
  methods: {

    // 抽奖点击
    clickDraw() {
      this.luckDrawClick();
    },

    // 开始抽奖
    luckDrawClick() {
      // 防止重复点击
      if (!this.clickFlag) {
        return;
      }
      this.clickFlag = false;
      const data = {
        token: this.$store.state.token, // this.$store.state.token,
        lottery_id: this.$store.state.lotteryId,
        brand_code: 2, // 1:RW 2:MG 4 RB
        lottery_joint_limit: this.jointLimitNum,
        last_modified_time: this.modifiedtime,
        method: 'getPrize',
      };
      api.startDraw(data).then((res) => {
        if (res.status === 'fail' && res.code === 500) {
          // 抽奖机会用完
          // this.winNumStatus = true;
          // this.clickFlag = true;
          return;
        } if (res.status === 'fail') {
          if (res.code === 401) {
            wx.miniProgram.navigateBack();
          } else {
            this.$toast(res.msg);
            this.clickFlag = true;
          }
          return;
        }
        const { id } = res.data;
        this.curPrizeId = id;
        this.resultData = res.data;
        // this.resultData = {
        //   bonus_desc: "车模",
        //   bonus_type: "custom",
        //   color: "#cccccc",
        //   id: 8,
        //   img: "https://dianshang-qa.ebanma.com:20016/images/09/52/6c/cb27c36598228a8c0e35823626547479edb92bf0.png",
        //   img_win: "",
        //   is_delivery: "on",
        // }
        this.setIn();
      }, () => {
        this.clickFlag = true;
      });
    },
    setIn() {
      let index = 0;
      this.setIntervalTimer = setInterval(() => {
        if (index === this.indexList.length - 1) {
          index = 0;
          // eslint-disable-next-line no-plusplus
          this.rotationNumber++;
          if (this.rotationNumber <= 2) {
            // 加速
            clearInterval(this.setIntervalTimer);
            this.sTime -= 10;
            this.setIn();
          } else {
            // 减速
            clearInterval(this.setIntervalTimer);
            this.sTime += 20;
            this.setIn();
          }
        } else if (index === 3) {
          index += 2;
        } else {
          // eslint-disable-next-line no-plusplus
          index++;
        }
        this.selectPrize = this.indexList[index];
        if (this.rotationNumber >= 3 && this.prizeList[this.indexList[index]].id === this.curPrizeId) {
          //  结束
          this.stopLuckDraw();
        }
      }, this.sTime);
    },
    stopLuckDraw() {
      clearInterval(this.setIntervalTimer);
      this.sTime = 100;
      this.rotationNumber = 0;
      this.setIDtoNum(this.curPrizeId);
      this.clickFlag = true;
      setTimeout(() => {
        this.selectPrize = '';
        this.resultStatus = true;
        this.$emit('endDraw', this.resultData);
      }, 500);
    },
    setIDtoNum(id) {
      let curIndex = '';
      this.prizeList.find((item, index) => {
        if (item.id === id) {
          curIndex = index;
          this.selectPrize = curIndex;
        }
        return item;
      });
    },
    closeResult() {
      this.resultStatus = false;
    },
    closeDrawDolag() {
      this.winNumStatus = false;
    },
  },
};
</script>
<style lang='stylus'>
.luck_draw {
  width: 320px;
  height: 320px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding:2px 4px 4px 2px;
  box-sizing: border-box;
  .luck_draw_prize {
    width: 92px;
    height: 92px;
    // background-color: #fff;
    margin-right: 10px;
    border-radius: 2px;
    overflow: hidden;
    position: relative;
    .prize-img{
      width:100%;
      height:100%;
      .prize-item{
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        .img{
          width:40px;
          height:40px;
        }
        .txt{
          font-size: 8px;
          color:rgb(12,170,209);
          font-weight: bold;
          padding: 10px 10px 0 10px;
          text-align center
          >span{
            color:rgb(234,102,5);
          }
        }
      }
      img{
        width:100%;
        height:100%;
      }
    }
    .start{
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction:column;
      height: 100%;
      background: url('../../assets/images/draw-bj@2x.png') no-repeat 0 0;
      background-size: cover;
      .t{
        font-family: PingFangSC-Medium;
        font-size: 16px;
        font-weight: bold;
        color: #fff;
        letter-spacing: 0.25px;
        text-align: center;
        padding-bottom: 10px;
      }
      .num{
        text-align: center;
        color:#fff;
        font-size: 12px;
        width:68px;
        height: 38px;
        background: #F0A500;
        border-radius: 20px;
        .n{
          padding-top: 3px;
        }
        .t2{
          font-size: 10px;
        }
      }
    }
    .end{
      height: 100%;
      text-align: center;
      font-size: 16px;
      background-color: #cccccc;
      color: #666;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .luck_draw_prize:nth-child(3n) {
    margin-right: 0px;
  }
  .select_sign {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background-color: #000;
    opacity: 0.4;
  }

  .not-win-modal-box{
    .top-img{
      height: 176px;
      background-size:cover;
      img{
        width:100%;
        height: 100%;
      }
    }
    .title{
      font-size: 17px;
      padding:14px 0 16px 0;
    }
    .no-win-title{
      margin-top: 50px;
    }
    .prize-name,.des{
      font-size: 14px;
      color: #6D7278;
      line-height: 24px;
      span{
        color: #000;
        margin-left: 5px;
      }
    }
    .gobtn{
      width:199px;
      height: 49px;
      text-align: center;
      color:#fff;
      background-color: #08A8D0;
      font-size: 14px;
      line-height: 49px;
      margin:24px auto auto;
      border-radius: 25px;
    }
  }
}
</style>
